import axios from "axios";
import store from "../store/index"
import {
	dayEnd,
	dayStart,
	yearStart,
	yearEnd,
	monthStart,
	monthEnd
} from "../util/DateUtil";
import {
	axiosApi,
	uploadApi
} from "./api"


/**
 * API 列表
 * @type {function(*=): *}
 */

// 获取所有区域
export const GET_AREAS = function () {
	return axiosApi("get", "/area/project/all")({
		projectId: store.getters.projectId
	})
}

// 通过区域id获取区域所有的回路 包含主回路
export const GET_AREA_LOOPS = function (areaId) {
	return axiosApi("get", "/loop/area/all/details")({
		areaId
	})
}

// 回路图表数据  按天获取
export const LOOP_DIAGRAM_DATA_BY_DAY = function (loopId, node, date) {
	let start = dayStart(date)
	let end = dayEnd(date)
	return axiosApi("get", "/diagram/loop")({
		deviceLoopId: loopId,
		node,
		start,
		end
	})
}

// 通过区域id获取主进线回路
export const GetLoopID = function (areaId) {

	return axiosApi("get", "/loop/master/area")({
		areaId,
	})
}

// 通过区域id获取区域的传感器
export const GetSensor = function (areaId) {
	return axiosApi("get", "/loop/sensor")({
		areaId,
	})
}

// 通过区域id获取区域的所有安防设备
export const GetSecurityDevices = function (areaId) {
	return axiosApi("get", "/device/security/all")({
		areaId,
	})
}

// 通过区域ID获取区域的所有EBOX和监控设备
export const GetEboxAndMonitor = function (areaId) {
	return axiosApi("get", "/device/security/ebox/all")({
		areaId
	})
}

// 通过项目ID获取项目信息
export const GetProJectInfo = function () {
	return axiosApi("get", "/project/info")({
		projectId: store.getters.projectId
	})
}

// 通过项目ID获取项目各个区域接线图
export const GET_WireByProjectId = function () {
	return axiosApi("get", "/diagram/wiring/tree")({
		projectId: store.getters.projectId
	})
}

// 通过回路ID查询当前电力数据
export const INFLUX_QUERY = (ids, date) => {

	return axiosApi("post", "/diagram/influxdb/data", true)({
		"deviceLoopIdList": ids,
		"start": dayStart(date),
		"end": dayEnd(date),
		"group": '1h',
		"nodes": [
			"Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "Pa", "Pb", "Pc", "U_unbl", "I_unbl"
		],
		projectId: store.getters.projectId
	})
	// {
	// 	"deviceLoopIdList": [
	// 		97, 84
	// 	],
	// 	"end": "2021-3-20T10:10:10Z",
	// 	"group": "1h",
	// 	"nodes": [
	// 		"P", "PFa"
	// 	],
	// 	"projectId": 2,
	// 	"start": "2021-3-19T10:10:10Z"
	// }
}

// 通过回路id查询极值
export const EXTREMUM_VALUES = (ids, nodes, type, date) => {
	return axiosApi("get", "/extremum/values")({
		ids: ids.join(","),
		nodes: nodes.join(","),
		type,
		"start": dayStart(date),
		"end": dayEnd(date),
	})
}

// 通过url得到监控信息
export const GetMinitorState = function () {
	return axiosApi("get", "/transfer/proxy")({
		url: 'https://ebox.vrmaker.com.cn/api/Room/GetCamerasState'
	})
}

// 通过回路ID查询当前回路的分合闸历史记录
export const GetSwitchingClosing = function (loopId) {
	return axiosApi("get", "/switchevent/list")({
		loopId,
	})
}

export const PostSwitchingClosing = function (eventType,loopId) {
	return axiosApi("post", "/switchevent/add")({
		eventType,
		loopId,
		userName: store.state.homeitem.user.realName,
	})
}

// 获取项目所有区域
export const GetAllAreas =  (data) =>{
	return axiosApi('get', '/area/project/all')(data)
}

// 通过区域ID拿到区域的所有变压器
export const GetAllTransformer = (data) => axiosApi('get', '/device/transformer/list')(data)
// 获取变压器功率
export const GetloopHistorycurve =(data) =>  axiosApi('get', '/diagram/loop/historycurve')(data)
// 获取日期用电量
export const diagramAreaDay =(data) =>  axiosApi('get', '/diagram/generation/area')(data)
// 获取日期用电量
export const diagramDay =(data) =>  axiosApi('get', '/diagram/generation')(data)

export const projectTime = () => axiosApi('get', '/project/time/deployment')()

// 按时间查询回路三相温度
export const loopTemperature = (data) => axiosApi('get', '/diagram/loop/historycurve/threetemperature')(data)

// 根据回路id和点位名获取相应数据历史曲线
export const loopHistorycurve = (data) => axiosApi('get', '/diagram/loop/historycurve')(data)



// 项目跳转获取项目信息
export const projectJump = function (data) {
	return axiosApi("get", "/user/projectJump")(data)
}